<script setup>
import { computed } from 'vue'

const props = defineProps({
  value: {
    type: Array,
    required: true,
  },
  size: {
    type: String,
    default: 'md',
  },
  buttonClass: {
    type: String,
    default: '',
  },
})

const emit = defineEmits(['input'])

const dirty = computed(() => !!props.value.filter((item) => item.state != null).length)

const getIconName = (item) => {
  if (item.state === true) return 'check-circle'
  if (item.state === false) return 'x-circle'
  return 'circle'
}

const getVariant = (item) => {
  if (item.state === true) return 'outline-success'
  if (item.state === false) return 'outline-danger'
  return 'outline-dark'
}

const onClick = (item) => {
  const toggleState = (currentState) => {
    if (currentState === null) return true
    if (currentState === true) return false
    return null
  }

  const newItemsState = { ...item, state: toggleState(item.state) }
  const newValue = props.value.map((i) => (i.value === item.value ? newItemsState : i))
  emit('input', newValue)
}

const onReset = () => {
  const resetState = props.value.map((item) => ({
    ...item,
    state: null,
  }))
  emit('input', resetState)
}
</script>

<template>
  <b-button-group>
    <template v-for="(item, i) in value">
      <b-button
        :key="i"
        :size="size"
        class="p-1"
        :class="buttonClass"
        variant="light"
        :disabled="!item.count && item.state === null"
        @click="onClick(item)"
      >
        <b-icon
          :icon="getIconName(item)"
          :variant="getVariant(item)"
        />
        {{ item.text }} ({{ item.count }})
      </b-button>
    </template>

    <b-button
      v-if="dirty"
      @click="onReset()"
      title="Reset filters"
      :class="buttonClass"
      variant="light"
      v-b-tooltip
      class="p-1"
    >
      <v-icon>mdi-filter-remove-outline</v-icon>
    </b-button>
  </b-button-group>
</template>
